// src/components/ui/ThemeSwitcher.jsx
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next'; // Dodajemy i18n
import './ThemeSwitcher.css';

function ThemeSwitcher() {
  // Pobieramy teraz wybór użytkownika, efektywny motyw i funkcję cykliczną
  const { userChoice, effectiveTheme, cycleTheme } = useTheme();
  const { t } = useTranslation();

  let buttonLabelKey;
  let nextModeDescriptionKey;

  // Ustalamy tekst przycisku na podstawie tego, co będzie *następne* po kliknięciu
  // bazując na aktualnym *wyborze użytkownika* (userChoice)
  if (userChoice === 'system') {
    buttonLabelKey = 'themeSwitcher.setLight'; // Po 'system' jest 'light'
    nextModeDescriptionKey = 'themeSwitcher.switchToLight';
  } else if (userChoice === 'light') {
    buttonLabelKey = 'themeSwitcher.setDark'; // Po 'light' jest 'dark'
    nextModeDescriptionKey = 'themeSwitcher.switchToDark';
  } else {
    // userChoice === 'dark'
    buttonLabelKey = 'themeSwitcher.setSystem'; // Po 'dark' jest 'system'
    nextModeDescriptionKey = 'themeSwitcher.switchToSystem';
  }

  // Dodajemy ikonkę pokazującą aktualnie *efektywny* motyw
  const currentIndicator = effectiveTheme === 'dark' ? '🌙' : '☀️';

  return (
    <button
      onClick={cycleTheme} // Wywołujemy funkcję cykliczną
      className="theme-switcher"
      title={t(nextModeDescriptionKey)} // Podpowiedź (tooltip)
      aria-label={t(nextModeDescriptionKey)} // Dla czytników ekranu
    >
      {/* Wyświetlamy wskaźnik obecnego trybu + tekst akcji */}
      {currentIndicator} {t(buttonLabelKey)}
    </button>
  );
}

export default ThemeSwitcher;
